import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useParams } from 'react-router-dom'
import useQueryGetDynamicPageById from '@/modules/client-setting/api/hooks/useQueryGetDynamicPageById'
import DynamicPageByIdListing from '@/modules/client-setting/components/DynamicPageById/components/DynamicPageByIdListing'
import { useTablePagination } from '@/common/hooks/useTablePaginate'

function DynamicPageById() {
	const { id } = useParams()
	const { pageSize, currentPage } = useTablePagination()

	const payload = {
		skip: (currentPage - 1) * pageSize,
		take: pageSize,
	}

	const { data, isLoading } = useQueryGetDynamicPageById(id!, payload)

	return (
		<PageContainer>
			<DynamicPageByIdListing
				data={data?.dynamicPageSections || []}
				name={data?.name || ''}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedDynamicPageById = withUserPermission(DynamicPageById, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.WEB_SETTING],
})

export default GuardedDynamicPageById
